import React, {useEffect} from 'react';
import {Link} from "react-router-dom";
import { useTranslation } from "react-i18next";

const JacobPage = () => {

    const { t } = useTranslation();

    useEffect(() => {
        const meta = document.createElement('meta');
        meta.name = 'robots';
        meta.content = 'noindex, nofollow';
        document.head.appendChild(meta);
        return () => document.head.removeChild(meta);
    }, []);

    return (
        <div className="vcard-page">
            <h1>Jacob Lacasse</h1>
            <a className="vcard-button" href={`${process.env.PUBLIC_URL + '/jacob.vcf'}`}>
                <i className="fa fa-user-plus"/> {t("vcard_add")}
            </a>
            <Link className="vcard-home" to={`${process.env.PUBLIC_URL + '/'}`}>
                <i className="fa fa-home"/> {t("error_back")}
            </Link>
        </div>
    );
};

export default JacobPage;
